(function () {
  var lightbox = document.querySelector('[data-dp-gallery-lightbox]');
  var lightboxImg = document.querySelector('[data-dp-gallery-lightbox-image]');
  var closeBtn = document.querySelector('[data-dp-gallery-lightbox-close]');
  if (!lightbox || !lightboxImg) return;

  function openLightbox() {
    var mainImg = document.querySelector('.dp-gallery__main-image');
    if (!mainImg) return;
    var zoomSrc = mainImg.getAttribute('data-zoom-src') || mainImg.src;
    lightboxImg.src = zoomSrc;
    lightboxImg.alt = mainImg.alt;
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lightbox.hidden = true;
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-dp-gallery-zoom-trigger]').forEach(function (el) {
    el.addEventListener('click', openLightbox);
  });
  if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox || e.target === lightboxImg) closeLightbox();
  });
})();